export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] w-full rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/096be9c57cd562040b50de9c711536fc/300fd1fa572488b3fcbdf05ecda17c82.png"
                alt="Mow and Snow professional team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-yellow-400 to-yellow-500 text-gray-900 p-8 rounded-xl shadow-xl">
              <div className="text-3xl font-bold">GTA&apos;s</div>
              <div className="text-lg font-medium mt-1">Trusted Choice</div>
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-yellow-50 text-yellow-700 rounded-full text-sm font-semibold mb-4">
              About Mow and Snow
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              Your Trusted GTA Landscaping Partner
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Mow and Snow has been proudly serving homeowners and businesses throughout the Greater Toronto Area for many years. Our experienced team handles everything from routine maintenance to complex construction projects with the professionalism and reliability our clients have come to depend on.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              What sets us apart? Our hassle-free monthly plan covers all your property needs for one predictable price. No surprise charges, no hidden fees – just exceptional service you can count on, season after season.
            </p>

            <div className="grid sm:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-yellow-100 rounded-lg flex-shrink-0">
                  <i className="ri-team-line text-2xl text-yellow-600"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Expert Team</h3>
                  <p className="text-gray-600 text-sm">Certified professionals with years of experience</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-cyan-100 rounded-lg flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-cyan-600"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">GTA-Wide Service</h3>
                  <p className="text-gray-600 text-sm">Serving all Greater Toronto Area communities</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg flex-shrink-0">
                  <i className="ri-calendar-check-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Year-Round Care</h3>
                  <p className="text-gray-600 text-sm">Comprehensive service in every season</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg flex-shrink-0">
                  <i className="ri-price-tag-3-line text-2xl text-orange-600"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Flat Monthly Rate</h3>
                  <p className="text-gray-600 text-sm">Predictable pricing with no surprises</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
